export default "__VITE_ASSET__CkawfR$Z__"